/**
 * Outfit font assets — what the DS needs loaded before its first screen renders.
 *
 * The DS declares the families it styles with (`theme/tokens/typography.ts`); the app shell
 * loads them. `App.js` spreads `dsFontAssets` into its `expo-font` `useFonts({...})` call, which
 * blocks the first render on native and registers the `@font-face` set on web. Storybook has no
 * `App.js`, so it registers the same families from `.storybook/fonts.css` instead.
 *
 * `@expo-google-fonts/outfit` is a plain asset package — JS module ids + `.ttf` files, no native
 * code. Each weight is imported by its own subpath so the package's `useFonts` helper (and its
 * `expo-font` dependency) never enters the DS graph.
 *
 * Deliberately NOT re-exported from `theme/index.ts`: the barrel is imported by every story, and
 * a `.ttf` require has no place in the Storybook bundle.
 *
 * The map's keys ARE the family names components resolve through `theme.fontFamilies.*` — keep
 * the two in sync. Legacy screens keep Montserrat; this is the DS's own font layer.
 */
import { Outfit_300Light } from "@expo-google-fonts/outfit/300Light"
import { Outfit_400Regular } from "@expo-google-fonts/outfit/400Regular"
import { Outfit_500Medium } from "@expo-google-fonts/outfit/500Medium"
import { Outfit_600SemiBold } from "@expo-google-fonts/outfit/600SemiBold"
import { Outfit_700Bold } from "@expo-google-fonts/outfit/700Bold"
import { Outfit_800ExtraBold } from "@expo-google-fonts/outfit/800ExtraBold"
import { Outfit_900Black } from "@expo-google-fonts/outfit/900Black"

export const dsFontAssets = {
    Outfit_300Light,
    Outfit_400Regular,
    Outfit_500Medium,
    Outfit_600SemiBold,
    Outfit_700Bold,
    Outfit_800ExtraBold,
    Outfit_900Black,
} as const
